import React from 'react';
import styles from './ToggleSwitch.module.css';

const ToggleSwitch = ({ label, checked, onChange }) => {
  return (
    <label className={styles.toggleLabel}>
      {label}
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className={styles.toggleInput}
      />
      <span className={styles.toggleSlider}></span>
    </label>
  );
};

export default ToggleSwitch;
